import {
  ColumnDef,
  ColumnDefResolved,
  ColumnSizingState,
} from '@tanstack/react-table';

import { GridColumnVisibilityModel } from '@/hooks/useDataGridState';
import { RunSchema } from '@/types/schema';

export function getColumnsAndSizing(
  columns: ColumnDef<RunSchema, string>[],
  columnSizing: ColumnSizingState,
  columnVisibilityModel: GridColumnVisibilityModel,
  peekedRunId: string | null
) {
  if (peekedRunId) {
    const newColumns = columns
      .filter(
        (column) =>
          columnVisibilityModel[
            column.id ??
              (column as ColumnDefResolved<RunSchema, string>).accessorKey ??
              ''
          ] !== false
      )
      .slice(0, 5);

    const newColumnVisibilityModel = Object.fromEntries(
      Object.entries(columnVisibilityModel).map(([key]) => [
        key,
        newColumns.some(
          (column) =>
            column.id === key ||
            (column as ColumnDefResolved<RunSchema, string>).accessorKey === key
        ),
      ])
    );

    const lastColumn = newColumns[newColumns.length - 1];

    const windowWidth = window.innerWidth;
    return {
      columnSizing: {
        ...columnSizing,
        [lastColumn?.id ?? '']: windowWidth * 0.8,
      },
      columnVisibilityModel: newColumnVisibilityModel,
    };
  }

  return {
    columnSizing,
    columnVisibilityModel,
  };
}
